import IFeatureFlags from '../common/components/feature-flag/interfaces/IFeatureFlags';
import LoginConstants from '../pages/login/constants';

export type realmType = 'ambev' | 'third';
export interface AppConfigContextData {
    APP_BASE_URL: string;
    API_AUTH_BASE_URL: string;
    API_CARRIER_BASE_URL: string;
    API_NOTIFICATION_BASE_URL: string;
    API_LOADMANAGER_BASE_URL: string;
    AUTH_BASE_URL: string;
    AMBEV_REALM: string;
    THIRD_REALM: string;
    CLIENT_ID: string;
    AMBEV_CLIENT_ID: string;
    THIRD_CLIENT_ID: string;
    RESPONSE_TYPE: string;
    PROTOCOL: string;
    REALMS: string;
    AUTH_URL: string;
    REDIRECT_URI: string;
    REFRESH_TOKEN_EXPIRES_IN_MILLISECONDS: number;
    OCP_APIM_SUBSCRIPTION_KEY: string;
    SMART_CARGAS_URL: string;
    ONTIME_LEILAO_URL: string;
    FEATURE_FLAGS: IFeatureFlags[];
    API_ROUNDMANAGER_API_BASE_URL: string;
    SMARTCARGAS_GOOGLE_STORE: string;
    SMARTCARGAS_APPLE_STORE: string;
    API_NOTIFICATION_WEB_SOCKET: string;
    SERVICE_NOW_URL_EXTERNAL: string;
    SERVICE_NOW_URL_INTERNAL: string;
}

class ConfigurationManager {
    private static instance: ConfigurationManager;

    private config: AppConfigContextData;

    private readonly realmsPath = '/realms/';

    private count = -1;

    private constructor() {
        this.config = {} as AppConfigContextData;
    }

    public static getInstance(): ConfigurationManager {
        if (!ConfigurationManager.instance) {
            ConfigurationManager.instance = new ConfigurationManager();
        }
        return ConfigurationManager.instance;
    }

    private readConfigFile = async () => {
        const baseUrl = window.location.origin;
        const response = await fetch(
            `${baseUrl}/configuration/configuration.json`,
        );

        const configs: AppConfigContextData = await response.json();
        this.config = configs;
    };

    private customConfigs = (realm?: realmType) => {
        let realmSelected = null;

        if (realm === 'third') {
            this.config.CLIENT_ID = this.config.THIRD_CLIENT_ID;
            realmSelected = this.config.THIRD_REALM;
        } else {
            this.config.CLIENT_ID = this.config.AMBEV_CLIENT_ID;
            realmSelected = this.config.AMBEV_REALM;
        }

        this.config.REALMS = `${this.realmsPath}${realmSelected}`;
        this.config.AUTH_URL = `${this.config.AUTH_BASE_URL}${this.config.REALMS}${this.config.PROTOCOL}`;
        this.config.REDIRECT_URI = `${this.config.APP_BASE_URL}${LoginConstants.default}`;
    };

    public getConfigFile(realm?: realmType) {
        this.count = this.count >= 2 ? this.count : this.count + 1;

        if (Object.keys(this.config).length === 0) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            return new Promise<AppConfigContextData>((resolve, _) => {
                setTimeout(() => {
                    (async () => {
                        if (Object.keys(this.config).length === 0) {
                            await this.readConfigFile();
                        }

                        this.customConfigs(realm);

                        resolve(this.config);
                    })();
                }, 1000 * this.count);
            });
        }

        this.customConfigs(realm);

        return this.config;
    }
}

export default ConfigurationManager;
